import { AtlasDynamicFormValidationComponent } from "./atlas-dynamic-form/atlas-dynamic-form-validation.component";
import { AtlasDynamicFormComponent } from "./atlas-dynamic-form/atlas-dynamic-form.component";
import { AtlasCheckboxComponent } from "./controls/atlas-checkbox/atlas-checkbox.component";
import { AtlasInputComponent } from "./controls/atlas-input/atlas-input.component";
import { AtlasListSelectionComponent } from "./controls/atlas-list-selection/atlas-list-selection.component";
import { AtlasRadioButtonComponent } from "./controls/atlas-radio-button/atlas-radio-button.component";
import { AtlasSelectComponent } from "./controls/atlas-select/atlas-select.component";
import { AtlasSliderToggleComponent } from "./controls/atlas-slider-toggle/atlas-slider-toggle.component";

export const components = [
    AtlasDynamicFormComponent,
    AtlasInputComponent,
    AtlasSelectComponent,
    AtlasRadioButtonComponent,
    AtlasCheckboxComponent,
    AtlasDynamicFormValidationComponent,
    AtlasSliderToggleComponent,
    AtlasListSelectionComponent
];